import { render, staticRenderFns } from "./ToWhatsApp.vue?vue&type=template&id=bcb3efa2&"
import script from "./ToWhatsApp.vue?vue&type=script&lang=js&"
export * from "./ToWhatsApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports